import { FC, useCallback } from 'react';
import { useContextSelector } from 'use-context-selector';
import CreateShoppingListSidePanel from './CreateShoppingListSidePanel';
import { ViewShoppingListsContext } from './ViewShoppingListsContext';

const CreateShoppingListSidePanelContainer: FC = () => {
  const isCreateShoppingListPanelOpen = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.isCreateShoppingListPanelOpen
  );
  const closeCreateShoppingListPanel = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.closeCreateShoppingListPanel
  );

  const handleSaveSuccess = useCallback(() => {
    closeCreateShoppingListPanel();
  }, [closeCreateShoppingListPanel]);

  return (
    <CreateShoppingListSidePanel
      isOpen={isCreateShoppingListPanelOpen}
      onClose={closeCreateShoppingListPanel}
      onSaveSuccess={handleSaveSuccess}
    />
  );
};

export default CreateShoppingListSidePanelContainer;
